function comparePaymentEntriesByDate(left, right) {
  if (left.date && right.date) return right.date.getTime() - left.date.getTime();
  if (left.date) return -1;
  if (right.date) return 1;
  return 0;
}

export function mergeAndSortPaymentEntries(baseEntries, syntheticEntries) {
  const normalizedBase = Array.isArray(baseEntries) ? baseEntries : [];
  const normalizedSynthetic = Array.isArray(syntheticEntries) ? syntheticEntries : [];

  if (normalizedSynthetic.length === 0) return normalizedBase;

  const existingChannelIds = new Set(
    normalizedBase
      .filter((entry) => entry?.isChannelSubscription && entry?.channelId)
      .map((entry) => String(entry.channelId))
  );
  const entries = [
    ...normalizedBase,
    ...normalizedSynthetic.filter((entry) => (
      entry && (!entry.channelId || !existingChannelIds.has(String(entry.channelId)))
    )),
  ];

  return entries.sort(comparePaymentEntriesByDate);
}
